const env = import.meta.env;

export const APP_ENV = env.VITE_APP_ENV || env.MODE;
export const API_BASE_URL = env.VITE_REACT_APP_API_URL;
export const IS_PRODUCTION = APP_ENV === "production";
export const IS_DEVELOPMENT = !IS_PRODUCTION;
